import { render, staticRenderFns } from "./handleIndex.vue?vue&type=template&id=7fc56cb6&scoped=true"
import script from "./handleIndex.vue?vue&type=script&lang=js"
export * from "./handleIndex.vue?vue&type=script&lang=js"
import style0 from "./handleIndex.vue?vue&type=style&index=0&id=7fc56cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc56cb6",
  null
  
)

export default component.exports